/**
 * 桁数付きテキストフィールド
 * @see テキストフィールド
 * @see ABUI_doc__Component_TextField.html#textField_digits
 */

if($('.textfield-digit').length){
  $('.textfield-digit').each(function() {
    /**
     * ターゲットとなる入力フィールド取得
     * @type {Object}
     */
    const input = $(this).find('.form-control');

    /**
     * 最大文字数を数値化
     * @type {Number}
     */
    const length = parseInt(input.attr('maxlength'));

    /**
     * 文字列
     * @type {String}
     */
    let str = '';

    /**
     * 入力フィールドのサイズ（クラス名）取得
     * @type {String}
     */
    let size = '';

    /**
     * 入力フィールドのパディングを取得して数値化
     * @type {Number}
     */
    const paddingW = parseInt(input.css('padding-left'));

    /**
     * フォント（1文字）の幅
     * @type {Number}
     */
    const fWidth = parseInt(input.css('font-size'))*0.73;

    /**
     * 横幅を算出
     * @type {Number}
     */
    const w = fWidth*length + fWidth*(length - 1)/2 + paddingW*2;

    /**
     * アンダーライン
     * @type {String}
     */
    let underline;

    /**
     * 文字数分ループする
     */
    for (let i=0; i<length; i=(i+1)|0) {
      str = str + '&ndash;';
    }

    /* 文字幅を取得する方法　希望の値が得られず　要再考 */
    // var fSize = parseInt(input.css('font-size'));
    // input.before('<span id="elm">0</span>');
    // $('#elm').css({
    //   'position': 'absolute',
    //   'z-index': '-1',
    //   'opacity': '0',
    //   'font-family': '"Courier New", monospace',
    //   'font-size': fSize
    // });
    // var fWidth = $('#elm').get(0).offsetWidth;
    // $('#elm').remove();

    if (input.hasClass('input-sm')) {
      size = 'input-sm';
    } else if (input.hasClass('input-lg')) {
      size = 'input-lg';
    } else if (input.hasClass('input-hg')) {
      size = 'input-hg';
    } else {
      size = '';
    }

    input.css('width', w + 'px');

    /**
     * アンダーラインを描画
     * @type {String}
     */
    underline = '<input type="text" class="' + size + ' form-control digit-underline" style="padding-left:' + paddingW + 'px; width: ' + w + 'px;" placeholder="" value="' + str + '" disabled>';
    input.before(underline);
  });
}